'use client';

import { useEffect } from 'react';

export default function ConsoleEasterEgg() {
  useEffect(() => {
    let isConsoleOpen = false;

    const checkConsole = () => {
      const before = performance.now();
      // Use `console.log` with a large object to detect dev tools
      console.log('%c ', 'font-size: 200px; background: transparent;');
      const after = performance.now();

      // If the time taken is unexpectedly large, the console is likely open
      isConsoleOpen = after - before > 100;

      if (isConsoleOpen) {
        triggerEasterEgg();
      }
    };

    const triggerEasterEgg = () => {
      const hackerStyle = `
        font-size: 16px;
        font-weight: bold;
        color: #00FF00;
        background: #000;
        padding: 4px;
        border-radius: 4px;
      `;
      const emojiStyle = `
        font-size: 24px;
        color: #FFD700;
        text-shadow: 0 0 5px #00FF00;
      `;

      console.log('%c🤘 Yo, fellow hacker! 🤘', emojiStyle);
      console.log('%c"Before you dig around here, hit me up 👇 and let\'s be friends cool 🤝"', hackerStyle);
      console.log(
        '%cGitHub: %chttps://github.com/Cdaprod\n%cX (Twitter): %chttps://x.com/cdasmktcda',
        'color: #FFD700; font-size: 14px;',
        'color: #00FF00; font-weight: bold; text-decoration: underline;',
        'color: #FFD700; font-size: 14px;',
        'color: #00FF00; font-weight: bold; text-decoration: underline;'
      );
      console.log('%c⚡ Super cool vibes guaranteed. Catch ya on the other side! ⚡', hackerStyle);
      console.log('%cP.S. Don\'t do anything I wouldn\'t do! 😉', hackerStyle);
    };
    
    // Set an interval to constantly check for console open state
    const interval = setInterval(checkConsole, 500);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  return null; // This component doesn't render anything, it just runs the script
}